export default () => ({
  comment: '',
  cfdis: [{ cfdi: null, amount: 0 }],
  doNotBillTransaction: false
});
